import { render } from "./RatingStars.vue?vue&type=template&id=15b49cda&scoped=true&ts=true"
import script from "./RatingStars.vue?vue&type=script&lang=ts"
export * from "./RatingStars.vue?vue&type=script&lang=ts"

import "./RatingStars.vue?vue&type=style&index=0&id=15b49cda&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b49cda"]])

export default __exports__